import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import ProfileServices from "../../components/pages/account-info/profileService/ProfileService";

// ProfileData tipi
interface ProfileData {
  name: string;
  surname: string;
  email: string;
  number: string;
  address: string;
  fin: string;
  new_password: string;
  confirm_password: string;
  number_prefix: string;
  password: string;
}

// UserData tipi
interface UserData {
  name: string;
  surname: string;
  email: string;
  number: string;
  number_prefix: string;
  fin: string;
  address: string;
  password: string;
  new_password: string;
  confirm_password: string;
}

// UserState tipi
interface UserState {
  isUser: boolean;
  isLogin: boolean;
  isRegister: boolean;
  isForgetPassword: boolean;
  isRecoveryPassword: boolean;
  isOtpVerified: boolean;
  isModalMessage: boolean;
  ForgetPasswordEmail: string;
  isChangePassword: boolean;
  userData: UserData | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  isLogin: true,
  isUser: false,
  isRegister: false,
  isForgetPassword: false,
  isRecoveryPassword: false,
  isOtpVerified: false,
  isModalMessage: false,
  ForgetPasswordEmail: "",
  isChangePassword: false,
  userData: null,
  loading: false,
  error: null,
};

export const fetchUserData = createAsyncThunk(
  "user/fetchUserData",
  async (_, thunkAPI) => {
    try {
      const response = await ProfileServices.ProfileData(); // İstifadəçi məlumatlarını alırıq
      return response; // Müvəffəqiyyətli cavab olaraq bu məlumatı geri qaytarırıq
    } catch (error: any) {
      return thunkAPI.rejectWithValue("Məlumat alınmadı"); // Xəta baş verərsə, xətanı qaytarırıq
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setIsUser(state, action: PayloadAction<boolean>) {
      state.isUser = action.payload;
    },
    setIsRegister(state, action: PayloadAction<boolean>) {
      state.isRegister = action.payload;
    },
    setIsLogin(state, action: PayloadAction<boolean>) {
      state.isLogin = action.payload;
    },
    setIsForgetPassword(state, action: PayloadAction<boolean>) {
      state.isForgetPassword = action.payload;
    },
    setIsRecoveryPassword(state, action: PayloadAction<boolean>) {
      state.isRecoveryPassword = action.payload;
    },
    setIsOtpVerified(state, action: PayloadAction<boolean>) {
      state.isOtpVerified = action.payload;
    },
    setIsMessage(state, action: PayloadAction<boolean>) {
      state.isModalMessage = action.payload;
    },
    setForgetPaswordEmail(state, action: PayloadAction<string>) {
      state.ForgetPasswordEmail = action.payload;
    },
    setChangePassword(state, action: PayloadAction<boolean>) {
      state.isChangePassword = action.payload;
    },
    setUserData(state, action: PayloadAction<UserData>) {
      state.userData = action.payload;
    },
    updateUserData(state, action: PayloadAction<Partial<UserData>>) {
      if (state.userData) {
        state.userData = { ...state.userData, ...action.payload };
      }
    },
    clearUserData(state) {
      state.userData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload; // Burada `userData` redux store-a əlavə olunur
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string; // Xəta baş verərsə, xətanı saxlayırıq
      });
  },
});

export const {
  setIsUser,
  setIsRegister,
  setIsLogin,
  setIsForgetPassword,
  setIsRecoveryPassword,
  setIsOtpVerified,
  setIsMessage,
  setForgetPaswordEmail,
  setChangePassword,
  setUserData,
  updateUserData,
  clearUserData,
} = userSlice.actions;

export default userSlice.reducer;
